import React, { useRef, useEffect} from 'react';
import "../Components/text.css";
import Peopletab from '../Home/Components/Peopletab';
import adnan from "../Assets/Images/Peopleimages/Adnan-Yaqub.jpeg";
import naveed from "../Assets/Images/Peopleimages/Dr.-Naveed-ALamCEO.jpg";
import toby from "../Assets/Images/Peopleimages/Toby-McNeill.jpeg";
import hansImage from "../Assets/Images/Peopleimages/Hans-watersprint-1.jpg";
import arshadImage from "../Assets/Images/Peopleimages/Arshad_mian.jpg";
import sheraz from "../Assets/Images/Peopleimages/sheraz.jpg"

function Aboutus() {
    
  const expertiesedat = [
    {
      name: "Adnan Yaqub Chaudhry",
      title: "Company Secretary & Director",
      image: adnan,
    },
    {
      name: "Dr. Naveed Alam",
      title: "Climate & Water Expert",
      image: naveed,
    },
    {
      name: "Toby McNeill",
      title: "Finance Expert",
      image: toby,
    },
    {
      name: "Dr. Hans Beekman",
      title: ["Key Expert and Advisor —", "Water Management and Hydrogeologist"],
      image: hansImage,
    },
    {
      name: "Sheraz Hussain",
      title: ["Technology expert"],
      image: sheraz,
    },
    {
      name: "Muhammad Arshad Mian",
      title: "Project Management Expert",
      image: arshadImage,
    },
  ];

  const scrollContainerRef = useRef(null);
 

 
  const [isPaused] = React.useState(false);

  // Auto-scroll carousel effect
  useEffect(() => {
    const container = scrollContainerRef.current;
    if (!container || isPaused) return;

    const autoScroll = setInterval(() => {
      const { scrollLeft, scrollWidth, clientWidth } = container;
      
      // Check if we've reached the end
      if (scrollLeft + clientWidth >= scrollWidth - 5) {
        // Reset to start
        container.scrollTo({ left: 0, behavior: 'smooth' });
      } else {
        // Scroll by one card width (310px = 280px card + 30px gap)
        container.scrollBy({ left: 310, behavior: 'smooth' });
      }
    }, 3000); // 3 second delay between scrolls

    return () => clearInterval(autoScroll);
  }, [isPaused]);

  return (
    <>
      <style>{`
        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes float {
          0%, 100% {
            transform: translateY(0px);
          }
          50% {
            transform: translateY(-10px);
          }
        }

        @keyframes shimmer {
          0% {
            background-position: -1000px 0;
          }
          100% {
            background-position: 1000px 0;
          }
        }

        .animate-fadeInUp {
          animation: fadeInUp 0.6s ease-out forwards;
        }

        .animate-float {
          animation: float 3s ease-in-out infinite;
        }

        .gradient-text {
          background: linear-gradient(135deg, #14B88F 0%, #0d8a6b 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
        }

        .glass-card {
          background: rgba(255, 255, 255, 0.9);
          backdrop-filter: blur(10px);
          border: 1px solid rgba(20, 184, 143, 0.1);
        }

        .value-card {
          position: relative;
          overflow: hidden;
        }

        .value-card::before {
          content: '';
          position: absolute;
          top: 0;
          left: -100%;
          width: 100%;
          height: 100%;
          background: linear-gradient(90deg, transparent, rgba(20, 184, 143, 0.1), transparent);
          transition: left 0.5s;
        }

        .value-card:hover::before {
          left: 100%;
        }

        .section-divider {
          width: 80px;
          height: 4px;
          background: linear-gradient(90deg, #14B88F, #0d8a6b);
          margin: 1rem auto;
          border-radius: 2px;
        }

        .icon-bounce:hover {
          animation: float 0.5s ease-in-out;
        }
      `}</style>

      <div
        style={{
          display: "flex",
          width: "100%",
          maxWidth: "1400px",
          margin: "0 auto",
          flexDirection: "column",
          alignItems: "center",
          gap: "60px",
          textAlign: "center",
          marginTop: "5%",
          padding: "0 40px",
        }}
      >
        {/* Hero Section */}
        <div className="animate-fadeInUp" style={{ width: "100%" }}>
          <div style={{
            background: "linear-gradient(135deg, #14B88F15 0%, #14B88F05 100%)",
            borderRadius: "24px",
            padding: "60px 40px",
            border: "2px solid #14B88F20"
          }}>
            <h1 className="gradient-text" style={{ 
              fontSize: "48px", 
              fontWeight: "800",
              marginBottom: "20px",
              letterSpacing: "-1px"
            }}>
              About Us
            </h1>
            <div className="section-divider"></div>
            <p style={{
              fontSize: "18px",
              lineHeight: "1.8",
              color: "#4a5568",
              maxWidth: "900px",
              margin: "30px auto 0",
              fontFamily: "arial"
            }}>
              At WaterSprint, we believe in the power of technology to address the world's most pressing challenges. As the innovation studio of the WaterSprint group, we are at the forefront of digital transformation, seamlessly integrating cutting-edge software engineering with specialized climate science and precise quantity surveying expertise.
            </p>
          </div>
        </div>

        {/* Mission Section */}
        <div className="animate-fadeInUp glass-card" style={{
          width: "100%",
          padding: "50px 40px",
          borderRadius: "24px",
          boxShadow: "0 10px 40px rgba(20, 184, 143, 0.1)"
        }}>
          {/* <div className="animate-float" style={{ 
            fontSize: "48px", 
            marginBottom: "20px",
            display: "inline-block"
          }}>
            🎯
          </div> */}
          <h2 className="gradient-text" style={{ 
            fontSize: "36px", 
            fontWeight: "700",
            marginBottom: "15px"
          }}>
            Our Mission
          </h2>
          <div className="section-divider"></div>
          <p style={{
            fontSize: "17px",
            lineHeight: "1.8",
            color: "#4a5568",
            maxWidth: "800px",
            margin: "20px auto 0"
          }}>
            To harness the fusion of advanced technology and scientific insight to create impactful digital products that accelerate innovation, foster sustainability, and deliver tangible value for our clients and the planet.
          </p>
        </div>

        {/* Values Section */}
        <div style={{ width: "100%" }}>
          <h2 className="gradient-text" style={{ 
            fontSize: "42px", 
            fontWeight: "700",
            marginBottom: "15px"
          }}>
            Our Values
          </h2>
          <div className="section-divider"></div>
          <p style={{
            fontSize: "16px",
            color: "#000",
            marginBottom: "50px"
          }}>
            The principles that guide everything we do
          </p>

          <div style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))",
            gap: "30px",
            width: "100%",
            height:"auto",
            // marginLeft: "-15%"
          }}>
            {[
              {
                icon: <svg width="18" height="22" viewBox="0 0 18 22" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M13.5 20.75C13.5 21.1642 13.1642 21.5 12.75 21.5H5.25C4.83579 21.5 4.5 21.1642 4.5 20.75C4.5 20.3358 4.83579 20 5.25 20H12.75C13.1642 20 13.5 20.3358 13.5 20.75ZM17.25 8.75C17.2565 11.2836 16.0926 13.6783 14.0963 15.2384C13.723 15.5246 13.5029 15.9672 13.5 16.4375V17C13.5 17.8284 12.8284 18.5 12 18.5H6C5.17157 18.5 4.5 17.8284 4.5 17V16.4375C4.49969 15.9728 4.28398 15.5344 3.91594 15.2506C1.9248 13.6999 0.757338 11.3197 0.75 8.79594C0.725625 4.32781 4.33688 0.606875 8.80125 0.5C11.0235 0.446448 13.1734 1.29194 14.7638 2.84496C16.3542 4.39798 17.2506 6.52709 17.25 8.75ZM15.75 8.75C15.7505 6.93116 15.017 5.18908 13.7157 3.91842C12.4143 2.64775 10.6552 1.95604 8.83687 2C5.18062 2.08625 2.23031 5.13031 2.25 8.78656C2.25694 10.8506 3.21244 12.7969 4.84125 14.0647C5.57354 14.634 6.00133 15.51 6 16.4375V17H12V16.4375C12.0021 15.5074 12.4335 14.6303 13.1691 14.0609C14.8031 12.784 15.7556 10.8238 15.75 8.75ZM14.2397 7.87438C13.8414 5.64954 12.0996 3.90815 9.87469 3.51031C9.46617 3.44145 9.07917 3.71679 9.01031 4.12531C8.94145 4.53383 9.21679 4.92082 9.62531 4.98969C11.1788 5.25125 12.4969 6.56937 12.7603 8.12562C12.8216 8.4863 13.1342 8.75014 13.5 8.75C13.5424 8.74975 13.5847 8.7463 13.6266 8.73969C14.0348 8.67 14.3093 8.28262 14.2397 7.87438Z" fill="#14B88F"/>
</svg>
,
                title: "Innovation",
                desc: "We embrace creativity and cutting-edge technology to develop novel solutions.",
                color: "#14B88F"
              },
              {
                icon: <svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M16.5 0.75H1.5C0.671573 0.75 0 1.42157 0 2.25V7.75969C0 16.1606 7.10812 18.9478 8.53125 19.4212C8.8352 19.5246 9.1648 19.5246 9.46875 19.4212C10.8938 18.9478 18 16.1606 18 7.75969V2.25C18 1.42157 17.3284 0.75 16.5 0.75ZM16.5 7.76156C16.5 15.1134 10.2797 17.5697 9 17.9972C7.73156 17.5744 1.5 15.12 1.5 7.76156V2.25H16.5V7.76156Z" fill="#14B88F"/>
</svg>,
                title: "Integrity",
                desc: "We uphold the highest ethical standards in all our actions.",
                color: "#0d8a6b"
              },
              {
                icon: <svg width="20" height="18" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M19.75 16.5C19.75 16.9142 19.4142 17.25 19 17.25H1C0.585786 17.25 0.25 16.9142 0.25 16.5V1.5C0.25 1.08579 0.585786 0.75 1 0.75C1.41421 0.75 1.75 1.08579 1.75 1.5V10.3472L6.50594 6.1875C6.77266 5.95401 7.16644 5.93915 7.45 6.15187L12.9634 10.2872L18.5059 5.4375C18.704 5.24149 18.9943 5.1714 19.2599 5.2555C19.5256 5.33959 19.7227 5.56402 19.7718 5.83828C19.8209 6.11254 19.714 6.39143 19.4941 6.5625L13.4941 11.8125C13.2273 12.046 12.8336 12.0608 12.55 11.8481L7.03656 7.71469L1.75 12.3403V15.75H19C19.4142 15.75 19.75 16.0858 19.75 16.5Z" fill="#14B887"/>
</svg>,
                title: "Impact",
                desc: "We are committed to creating measurable, positive change.",
                color: "#14B88F"
              },
              {
                icon: <svg width="24" height="16" viewBox="0 0 24 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M10.9921 10.8053C13.056 9.43132 13.9768 6.868 13.2591 4.49474C12.5414 2.12147 10.3543 0.498047 7.87493 0.498047C5.39551 0.498047 3.2085 2.12147 2.49076 4.49474C1.77303 6.868 2.69386 9.43132 4.75774 10.8053C2.93945 11.4755 1.38659 12.7156 0.330864 14.3406C0.179858 14.5651 0.16141 14.8534 0.282586 15.0953C0.403762 15.3371 0.645783 15.495 0.915957 15.5084C1.18613 15.5218 1.44259 15.3887 1.58711 15.16C2.97069 13.032 5.33669 11.7482 7.87493 11.7482C10.4132 11.7482 12.7792 13.032 14.1627 15.16C14.3916 15.5002 14.8513 15.5935 15.1947 15.3695C15.5382 15.1455 15.6381 14.6872 15.419 14.3406C14.3633 12.7156 12.8104 11.4755 10.9921 10.8053ZM3.74993 6.12533C3.74993 3.84715 5.59675 2.00033 7.87493 2.00033C10.1531 2.00033 11.9999 3.84715 11.9999 6.12533C11.9999 8.4035 10.1531 10.2503 7.87493 10.2503C5.59782 10.2477 3.75251 8.40243 3.74993 6.12533ZM23.4506 15.3785C23.1036 15.6047 22.639 15.5069 22.4127 15.16C21.0307 13.0306 18.6635 11.7469 16.1249 11.7503C15.7107 11.7503 15.3749 11.4145 15.3749 11.0003C15.3749 10.5861 15.7107 10.2503 16.1249 10.2503C17.7862 10.2488 19.2845 9.25074 19.926 7.71831C20.5676 6.18587 20.2273 4.41812 19.0626 3.23344C17.8979 2.04876 16.1362 1.67838 14.5931 2.29377C14.3426 2.40204 14.0531 2.36574 13.8371 2.19897C13.6211 2.03221 13.5127 1.76129 13.5541 1.49158C13.5955 1.22186 13.7801 0.99591 14.0362 0.901579C16.7108 -0.165104 19.7591 0.960335 21.0989 3.50916C22.4387 6.05798 21.6373 9.20703 19.2421 10.8053C21.0604 11.4755 22.6133 12.7156 23.669 14.3406C23.8952 14.6876 23.7974 15.1522 23.4506 15.3785Z" fill="#008080"/>
</svg>,
                title: "Collaboration",
                desc: "We work together with our clients and partners to achieve shared goals.",
                color: "#0d8a6b"
              },
              {
                icon:<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M17.9484 0.756562C17.9263 0.376768 17.6232 0.0737419 17.2434 0.0515625C10.1062 -0.3675 4.38938 1.78125 1.95188 5.8125C1.10697 7.19148 0.690616 8.79032 0.755625 10.4062C0.809062 11.8988 1.24406 13.4062 2.04844 14.8922L0.219375 16.7203C0.0298009 16.9099 -0.0442362 17.1862 0.0251527 17.4452C0.0945415 17.7041 0.296815 17.9064 0.555778 17.9758C0.814741 18.0452 1.09105 17.9711 1.28062 17.7816L3.10875 15.9525C4.59375 16.7559 6.10219 17.1909 7.59375 17.2444C7.69812 17.2481 7.80219 17.25 7.90594 17.25C9.41695 17.254 10.8993 16.8379 12.1875 16.0481C16.2188 13.6106 18.3684 7.89469 17.9484 0.756562ZM11.4141 14.7656C9.28125 16.0575 6.75656 16.0781 4.2225 14.8378L12.5316 6.52969C12.8246 6.23663 12.8246 5.76149 12.5316 5.46844C12.2385 5.17538 11.7634 5.17538 11.4703 5.46844L3.16219 13.7812C1.92562 11.25 1.94344 8.71875 3.23438 6.58969C5.30531 3.17062 10.2281 1.29844 16.4822 1.52156C16.7062 7.77094 14.8331 12.6947 11.4141 14.7656Z" fill="#008080"/>
</svg>,
                title: "Sustainability",
                desc: "We prioritize environmental responsibility in every aspect of our work.",
                color: "#14B88F"
              },
            ].map((item, i) => (
              <div
                key={i}
                className="value-card glass-card"
                style={{
                  padding: "35px 25px",
                  borderRadius: "20px",
                  border: "2px solid #e5e7eb",
                  transition: "all 0.3s ease",
                  cursor: "pointer"
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateY(-8px)";
                  e.currentTarget.style.borderColor = "#14B88F";
                  e.currentTarget.style.boxShadow = "0 15px 40px rgba(20, 184, 143, 0.25)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.borderColor = "#e5e7eb";
                  e.currentTarget.style.boxShadow = "none";
                }}
              >
                <div className="icon-bounce" style={{
                  background: `linear-gradient(135deg, ${item.color}15, ${item.color}05)`,
                  borderRadius: "50%",
                  width: "70px",
                  height: "70px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  margin: "0 auto 20px",
                  border: `2px solid ${item.color}30`
                }}>
                  {item.icon}
                </div>
                <h3 style={{
                  fontSize: "22px",
                  fontWeight: "700",
                  color: "#1f2937",
                  marginBottom: "12px"
                }}>
                  {item.title}
                </h3>
                <p style={{
                  fontSize: "14px",
                  lineHeight: "1.7",
                  color: "#6b7280"
                }}>
                  {item.desc}
                </p>
              </div>
            ))}
          </div>
        </div>

        {/* Team Section */}
        <div style={{ width: "100%" }}>
          <h2 className="gradient-text" style={{ 
            fontSize: "42px", 
            fontWeight: "700",
            marginBottom: "15px"
          }}>
            Our Team
          </h2>
          <div className="section-divider"></div>
          <p style={{
            fontSize: "16px",
            color: "#6b7280",
            marginBottom: "50px"
          }}>
            Meet the experts driving our mission forward
          </p>

          <div style={{
        width: "75%",
        maxWidth: "890px",
        textAlign: "center",
        margin: "0 auto",
        padding: "2rem 0",
        position: "relative",
      }}>
            <div
              ref={scrollContainerRef}
              style={{
                display: "flex",
                flexDirection: "row",
                overflowX: "auto",
                padding: "20px 0",
                gap: "30px",
                scrollBehavior: "smooth",
                scrollbarWidth: "none",
                msOverflowStyle: "none",
              }}
            >
              {expertiesedat.map((item, index) => (
                <div key={index} style={{ flex: "0 0 auto", width: "280px" }}>
                  <Peopletab image={item.image} Name={item.name} Title={item.title} />
                </div>
              ))}
            </div>

            <style>{`
              div::-webkit-scrollbar {
                display: none;
              }
            `}</style>
          </div>
        </div>

        {/* Why Work With Us Section */}
        <div style={{ width: "100%", marginTop: "40px" }}>
          <div style={{
            background: "linear-gradient(135deg, #14B88F10 0%, #14B88F05 100%)",
            borderRadius: "8px",
            padding: "70px 40px",
            border: "2px solid #14B88F20"
          }}>
            <h2 className="gradient-text" style={{ 
              fontSize: "48px", 
              fontWeight: "800",
              marginBottom: "10px"
            }}>
              Why Work With Us
            </h2>
            <p style={{
              fontSize: "20px",
            //   color: "#14B88F",
              fontWeight: "600",
              marginBottom: "60px"
            }}>
              From Code to Cloud to Climate.
            </p>

            <div style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))",
              gap: "35px"
            }}>
              {[
                {
                  icon:<svg width="68" height="65" viewBox="0 0 88 85" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M37.5467 0.216967C21.8305 2.7356 8.72578 13.1576 3.08589 27.6227C1.66477 31.2685 0.556345 36.3798 0.254118 40.6835L0 44.3017L0.662646 48.2379C2.30957 58.0227 5.9941 65.4815 12.4254 72.0485C18.5739 78.3277 25.9888 82.2813 35.8009 84.5133C38.976 85.2355 49.1993 85.1342 53.254 84.3406C65.7694 81.8904 77.5446 73.0227 83.4266 61.6175C89.4222 49.9924 89.5282 36.0991 83.7125 24.1375C78.3039 13.013 67.3946 4.3409 54.8113 1.16315L50.7376 0.134246L45.1121 0.020174C42.018 -0.0425274 38.6136 0.0458603 37.5467 0.216967ZM36.9648 2.12369C29.3835 3.10312 19.4589 8.38627 13.4761 14.6277C-5.34619 34.2642 -0.0919476 65.6942 24.1618 78.5498C34.431 83.9924 47.9396 84.9046 58.888 80.894C79.64 73.2927 90.765 51.4912 84.4268 30.847C83.2307 26.9512 80.7391 22.0408 78.2868 18.7463C76.1794 15.915 70.8467 10.7006 68.3521 9.03179C63.5243 5.8023 56.0861 2.84514 50.982 2.12634C48.0548 1.71387 40.148 1.71235 36.9648 2.12369ZM31.0324 24.2701C30.8811 24.4174 30.7573 26.7952 30.7573 29.5536V34.569L28.9144 34.6842L27.0716 34.7994L26.9692 47.1697L26.8671 59.54H32.3185H37.7698L37.6585 56.0461L37.5467 52.5522L35.0249 52.3633L32.5031 52.1745L32.4011 39.0231L32.2991 25.872L33.371 25.9918L34.443 26.1119L34.5493 32.2271L34.656 38.3428L35.3252 38.5188C35.6938 38.6159 36.5186 38.8093 37.1588 38.9486C39.0683 39.3645 40.8689 40.6654 42.0553 42.4867L43.1722 44.2016V48.0713C43.1722 51.9932 43.4714 52.8412 44.5472 51.972L45.1121 51.5154V47.6713V43.8269L46.1161 42.3194C47.41 40.3768 49.0736 39.2859 51.6125 38.7152L53.6474 38.2582V32.0904V25.923H54.6173H55.5872V39.1258V52.329L52.9684 52.4404L50.3497 52.5522V55.9517V59.3511H55.7812H61.2127V47.0753V34.7994L59.3808 34.6846L57.5488 34.5701L57.4409 29.3965L57.3331 24.2233H54.8113H52.2895L52.1832 30.5501L52.0769 36.8769H51.5151C50.1495 36.8769 46.726 38.7639 45.4419 40.2242L44.0638 41.7917L42.1631 39.947C40.9255 38.7454 39.5552 37.8586 38.2346 37.4038L36.2067 36.7057L36.1008 30.4647L35.9949 24.2233L33.6511 24.113C32.3619 24.0522 31.1837 24.1228 31.0324 24.2701ZM28.5203 47.144L28.6235 57.8403L32.2122 57.949L35.8009 58.0574V56.1726V54.2878L33.3761 54.1756L30.9513 54.0631L30.7573 45.3755L30.5633 36.688L29.4902 36.5679L28.4175 36.4478L28.5203 47.144ZM57.437 45.2811L57.3331 54.0631L54.7143 54.1749L52.0955 54.2863V56.1579V58.0291H55.7812H59.4669V47.2641V36.4991H58.504H57.5414L57.437 45.2811Z" fill="#008080"/>
</svg>,
                  title: "Three-in-One",
                  desc: "We offer a unique blend of climate and water intelligence, IT and data science solutions, and proprietary products.",
                },
                {
                  icon: <svg width="70" height="76" viewBox="0 0 80 76" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M31.8327 0.728961C24.0833 2.32341 17.4487 5.93572 11.5019 11.7988C5.36589 17.8482 1.72958 25.0784 0.537802 33.5989L0 37.4464L0.601214 41.9866C1.7349 50.5486 5.23373 57.8021 11.1311 63.8179C22.6398 75.5571 40.6205 79.25 55.7079 72.9733C61.0162 70.7649 64.7033 68.3097 68.8639 64.2125C84.1101 49.1991 83.6429 25.1739 67.8222 10.6371C64.2197 7.32707 58.6109 3.90201 54.2973 2.3779C47.5146 -0.0191235 38.6349 -0.67078 31.8327 0.728961ZM36.9155 1.40857C20.9712 2.67462 7.15209 13.778 2.94603 28.7019L1.92417 32.3291L1.93579 37.9188L1.94789 43.5084L2.94023 47.069C5.21825 55.2401 10.7211 62.8793 17.8722 67.7973C37.5055 81.3005 64.8984 74.17 75.165 52.8836C77.5761 47.8842 78.5467 43.4842 78.538 37.5941C78.5283 31.5144 77.3491 26.8652 74.4476 21.4721C71.671 16.312 68.2574 12.3196 63.8654 9.0976C55.6973 3.10456 46.9569 0.611112 36.9155 1.40857ZM24.4149 32.2127L24.5717 41.6452L25.931 44.3091C27.5976 47.5749 31.5733 51.1504 36.6386 53.9392L40.3039 55.9575L44.0554 53.9252C48.5476 51.4914 53.2309 47.1766 54.855 43.9742L56.0361 41.6452L56.1929 32.2127L56.3493 22.7801H40.3039H24.2585L24.4149 32.2127ZM25.7819 32.0785V39.9799L26.8057 42.6127L27.8295 45.2458L30.58 47.8707C33.4699 50.6282 38.9084 53.989 40.4811 53.989C41.7731 53.989 49.0631 49.2355 50.9611 47.1547C51.8257 46.2077 53.0465 44.3706 53.6748 43.0729L54.8163 40.7136L54.8211 32.4456L54.8259 24.1775H40.3039H25.7819V32.0785ZM42.9978 36.1175L37.705 41.4435L35.1898 39.0535C33.4883 37.4366 32.5588 36.8437 32.3163 37.2205C32.0951 37.5652 33.0415 38.8317 34.7889 40.531L37.6193 43.2834L43.5622 37.5787C49.0621 32.2988 49.949 31.1543 48.7451 30.8907C48.4953 30.8357 45.9089 33.188 42.9978 36.1175Z" fill="#008080"/>
</svg>,
                  title: "Credibility",
                  desc: "Trusted by global organizations, we bring unparalleled expertise and reliability to every project.",
                },
                {
                  icon: <svg width="75" height="61" viewBox="0 0 85 91" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M38.1833 0.122638C31.6887 1.40386 27.5832 2.725 23.6567 4.79865C1.91503 16.2786 -6.34917 44.6514 5.25391 67.9785C7.83483 73.1669 14.2932 80.4538 19.5831 84.1456C22.0838 85.8914 26.2885 88.0162 29.3872 89.1011L34.8131 91L42.7789 90.9974L50.7447 90.9941L55.034 89.4348C66.9845 85.0892 75.4374 77.4352 80.6004 66.2844C83.9191 59.1172 84.9755 54.1978 84.9884 45.8496L85 38.6517L83.6158 33.4168C78.5538 14.2672 63.3723 1.40975 44.3108 0.129178C41.7832 -0.0402995 39.0258 -0.0435677 38.1833 0.122638ZM34.8131 1.94959C13.455 6.39397 -1.29702 27.9412 1.38377 50.7762C2.6344 61.4238 6.4016 69.7498 13.3668 77.2579C21.131 85.6271 31.0153 89.9995 42.1661 89.9969C49.5418 89.9956 55.1112 88.6391 61.3998 85.3117L66.6193 82.551L71.6248 77.2651L76.6304 71.9799L79.4289 65.7851C83.8817 55.9299 85.038 47.3801 83.2604 37.4562C80.1997 20.3769 68.5053 6.84155 53.1957 2.65891C47.8868 1.20887 39.8622 0.899356 34.8131 1.94959ZM51.0676 24.5405C50.6044 25.7341 49.5903 26.7398 48.3893 27.1972L46.4554 27.9327L48.472 28.8553C49.7686 29.4482 50.7202 30.4853 51.1362 31.7607C51.9567 34.2734 52.635 34.2839 53.1019 31.7901L53.4678 29.8362L55.4763 28.924L57.485 28.0119L56.2595 27.5067C54.3256 26.7097 52.8893 25.1412 52.8893 23.8273C52.8893 21.9964 51.9046 22.3825 51.0676 24.5405ZM50.7802 26.5042L49.6895 27.7913L50.8991 29.4331L52.1087 31.0749L53.4212 29.5823L54.7343 28.0897L53.3029 26.6534L51.8709 25.2171L50.7802 26.5042ZM37.6508 35.4126C35.125 43.6287 34.7886 44.0075 27.7665 46.536L23.7836 47.9697L23.5979 49.2784L23.4128 50.5877L27.8872 52.1444C33.8235 54.2102 35.3431 55.8167 37.41 62.2084L39.1024 67.4432H40.2274H41.3524L43.1416 61.8812C45.1055 55.7761 45.9873 54.6814 50.2949 52.9912C56.662 50.4942 57.2748 50.1382 57.0726 49.0546C56.9457 48.3754 55.1007 47.314 52.0511 46.1656C49.3991 45.1664 46.7152 43.8001 46.0865 43.1287C45.4578 42.4574 44.1417 39.556 43.1625 36.6808L41.3818 31.4538L40.1851 31.2581L38.9884 31.0625L37.6508 35.4126ZM39.4749 33.2532C39.1906 34.0633 38.3285 36.5793 37.5595 38.8454C35.9302 43.6418 34.75 44.7915 28.9644 47.2152C26.6206 48.1974 24.7027 49.1907 24.7027 49.423C24.7027 49.6553 26.5765 50.4896 28.867 51.2774C34.2849 53.141 36.386 55.483 38.2427 61.7281C39.0203 64.3429 39.9345 66.3838 40.2746 66.2628C40.6153 66.1411 41.3408 64.4437 41.8873 62.4898C43.9443 55.1355 45.2483 53.6148 51.6044 51.157C53.5689 50.3973 55.1479 49.4812 55.1124 49.1213C55.0774 48.7614 53.2643 47.8008 51.0835 46.9862C45.7336 44.9884 44.0675 43.1131 42.1337 36.9117C41.2538 34.0895 40.4118 31.7809 40.2623 31.7809C40.1134 31.7809 39.7586 32.4432 39.4749 33.2532ZM60.3772 35.3249C59.9715 36.2757 59.0168 37.3096 58.2558 37.6217L56.8722 38.1897L58.4733 38.8611C59.3545 39.2308 60.2577 40.2182 60.4807 41.0551L60.887 42.5778L61.7693 40.8601C62.2546 39.9159 63.2816 38.9389 64.0512 38.6896L65.4507 38.2362L63.8043 37.5851C62.898 37.2271 61.9225 36.1828 61.6364 35.2647L61.1149 33.5955L60.3772 35.3249ZM60.2099 37.3848L59.4023 38.4239L60.2264 38.9684C61.118 39.5566 62.6934 39.1522 62.6934 38.3343C62.6934 38.0575 62.3165 37.4961 61.8557 37.0878L61.0175 36.3451L60.2099 37.3848Z" fill="#008080"/>
</svg>,
                  title: "Innovation Edge",
                  desc: "Our cutting-edge solutions leverage the latest technologies to drive impactful change.",
                },
                {
                  icon: <svg width="56" height="53" viewBox="0 0 56 53" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M22.5431 0.715285C18.5267 1.5063 15.9627 2.47036 12.7212 4.40758C3.86604 9.70008 -1.09777 19.7663 0.206225 29.7871C2.52775 47.631 22.5141 58.0468 40.0078 50.53C47.2605 47.414 53.0687 40.8398 55.2716 33.2537C56.2258 29.9678 56.246 23.3458 55.3116 20.0492C54.9283 18.6955 53.8668 16.1566 52.9529 14.4072L51.2919 11.2268L47.8108 7.96621L44.3301 4.70558L40.9007 3.10916C37.0827 1.33212 33.7187 0.495285 29.2003 0.198796L26.1743 0L22.5431 0.715285ZM22.7449 1.30448C13.3874 3.07281 5.15752 9.79399 2.18844 18.0923C-2.02774 29.8761 3.2911 43.0659 14.6893 49.0949C18.5694 51.1472 21.524 51.8856 26.8376 52.131L31.1316 52.329L34.2399 51.68C35.9494 51.3229 38.8285 50.3248 40.6376 49.4618L43.9267 47.8923L47.1919 44.849L50.4571 41.8057L52.3247 38.2164C56.058 31.0424 56.3586 23.8551 53.2289 16.6174C48.3962 5.44207 35.3991 -1.08675 22.7449 1.30448ZM26.3575 10.231C25.6353 11.287 24.5911 13.2894 24.0368 14.6802L23.0289 17.2093L22.8381 21.8501L22.6472 26.4909L21.0818 28.0979C20.2208 28.9817 19.4034 30.268 19.2658 30.9564C19.0266 32.1519 19.3546 35.7783 19.7572 36.3894C19.8625 36.5496 20.8167 35.8351 21.8778 34.8021C24.0307 32.7058 24.7622 32.4695 24.7622 33.8702V34.8168H27.9899H31.2176V33.8702C31.2176 32.4627 31.9511 32.7073 34.1495 34.8483C35.2369 35.907 36.2322 36.6742 36.3613 36.553C36.4904 36.4318 36.678 35.0005 36.7785 33.3723L36.9613 30.4119L35.0981 28.2653L33.2349 26.1183V22.1091V18.1002L32.2101 15.2346C31.2337 12.5056 28.6786 8.31079 27.9927 8.31079C27.8156 8.31079 27.0797 9.17488 26.3575 10.231ZM26.7089 10.6782C26.1154 11.5627 25.5118 12.7316 25.3682 13.275L25.1063 14.2637L26.6492 14.4863C28.6972 14.7821 31.0538 14.2784 30.8912 13.5802C30.729 12.8827 28.2888 9.06772 28.0056 9.06886C27.8858 9.06924 27.3024 9.79323 26.7089 10.6782ZM23.8883 17.2093C23.25 19.9038 23.3384 26.3781 24.061 29.8943L24.5669 32.3556H27.9834H31.4004L31.9499 30.273C32.6797 27.5046 32.7778 19.2623 32.1092 16.8306L31.5888 14.9373H28.0076H24.4261L23.8883 17.2093ZM26.376 18.1559C24.8856 19.5547 25.5635 21.6717 27.6522 22.1439L28.727 22.3866L29.5686 21.5968C30.6987 20.5361 30.6717 18.7489 29.5138 17.9882C28.307 17.1949 27.3456 17.246 26.376 18.1559ZM26.2949 19.1184L25.8273 20.0814L26.6702 20.8724L27.513 21.663L28.5313 21.4233C30.6608 20.9216 30.1831 18.1559 27.9669 18.1559H26.7621L26.2949 19.1184ZM21.173 28.9609L19.9206 30.2995V32.7789C19.9206 34.1428 20.0804 35.2019 20.2753 35.1323C20.4701 35.063 21.3646 34.3791 22.2623 33.6127L23.8947 32.2196L23.4291 29.9208C23.1733 28.6568 22.8425 27.6223 22.6944 27.6223C22.5464 27.6223 21.8617 28.2248 21.173 28.9609ZM32.5869 29.8814L32.1887 32.1409L33.9184 33.668C34.8693 34.5082 35.7154 35.1955 35.7985 35.1955C36.2116 35.1955 36.3916 31.6611 36.0252 30.7504C35.6141 29.7292 33.7356 27.6223 33.2361 27.6223C33.0981 27.6223 32.806 28.639 32.5869 29.8814ZM25.5691 33.6809V34.4382H27.9899H30.4107V33.6809V32.9236H27.9899H25.5691V33.6809ZM24.6278 36.584C24.4798 36.7226 24.3599 37.5322 24.3615 38.3827C24.364 39.9571 24.8679 40.8966 26.9288 43.1712L28.0863 44.4492L29.0808 43.3249C30.9908 41.1658 31.6182 39.9352 31.6194 38.3418C31.6202 37.469 31.4278 36.6427 31.1918 36.506C30.9021 36.3379 30.8488 36.6874 31.0276 37.5826C31.335 39.1211 30.5091 41.0583 28.9646 42.4199L27.9677 43.2988L26.9457 42.3397C25.5828 41.0602 24.767 38.7719 25.1858 37.4019C25.4929 36.3962 25.2334 36.0153 24.6278 36.584ZM26.4123 37.5985C26.3716 38.803 27.5529 40.9488 28.1533 40.761C28.8795 40.5338 30.1012 37.862 29.7905 37.1797L29.4904 36.5208L29.187 37.7867C28.5878 40.2851 27.5888 40.3104 26.8473 37.8461L26.4487 36.5208L26.4123 37.5985ZM19.1964 41.1435L18.105 42.1693L16.5957 42.2052L15.0863 42.2416L13.8723 43.3332C13.2046 43.9338 12.6583 44.6608 12.6583 44.949C12.6583 45.2375 13.2699 44.8645 14.0172 44.1209L15.376 42.7687H16.86C18.3346 42.7687 19.936 43.8028 20.4108 45.0622C20.5242 45.3629 20.7348 45.5075 20.8784 45.3837C21.0221 45.2599 20.6735 44.5135 20.1038 43.7255C19.5337 42.9372 19.1637 42.056 19.2819 41.7675C19.5684 41.067 21.4538 40.4217 22.3947 40.702C22.8094 40.8254 23.1483 40.7447 23.1483 40.5221C23.1483 40.2998 22.5048 40.1181 21.7181 40.1181H20.2874L19.1964 41.1435ZM33.0832 40.421C32.9734 40.5876 33.4903 40.7239 34.2319 40.7239C36.6764 40.7239 37.5524 42.109 36.0591 43.6131C35.6153 44.0603 35.253 44.7774 35.2538 45.2068L35.255 45.9873L36.039 44.7809C36.9012 43.4537 37.9913 42.7687 39.2412 42.7687C40.5965 42.7687 41.9933 43.5521 42.523 44.6089C42.8534 45.2689 43.0907 45.4333 43.221 45.0933C43.3295 44.81 42.8587 44.0527 42.174 43.4105L40.9297 42.2427L39.4022 42.206L37.8747 42.1693L36.7834 41.1435C35.7247 40.1484 33.5431 39.7224 33.0832 40.421Z" fill="#008080"/>
</svg>,
                  title: "Speed & Scale",
                  desc: "We deliver rapid, scalable solutions that meet the urgent needs of our clients and the planet.",
                },
              ].map((item, i) => (
                <div
                  key={i}
                  className="value-card glass-card"
                  style={{
                    padding: "40px 30px",
                    borderRadius: "8px",
                    border: "2px solid #e5e7eb",
                    background: "white",
                    transition: "all 0.3s ease",
                    cursor: "pointer"
                  }}
                //   onMouseEnter={(e) => {
                //     e.currentTarget.style.transform = "translateY(-10px) scale(1.02)";
                //     e.currentTarget.style.borderColor = "#14B88F";
                //     e.currentTarget.style.boxShadow = "0 20px 50px rgba(20, 184, 143, 0.3)";
                //   }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = "translateY(0) scale(1)";
                    e.currentTarget.style.borderColor = "#e5e7eb";
                    e.currentTarget.style.boxShadow = "none";
                  }}
                >
                  <div className="icon-bounce" style={{
                    // background: "linear-gradient(135deg, #14B88F15, #14B88F05)",
                    borderRadius: "50%",
                    width: "90px",
                    height: "90px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    margin: "0 auto 25px",
                    // border: "3px solid #14B88F30"
                  }}>
                    {item.icon}
                  </div>
                  <h3 style={{
                    fontSize: "24px",
                    fontWeight: "700",
                    color: "#1f2937",
                    marginBottom: "15px"
                  }}>
                    {item.title}
                  </h3>
                  <p style={{
                    fontSize: "15px",
                    lineHeight: "1.8",
                    color: "#6b7280"
                  }}>
                    {item.desc}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Aboutus;